import React from "react";
import DataGrid, { Column, FilterRow } from "devextreme-react/data-grid";
import { TelegramBinding, telegramService } from "../api/TelegramService";
import Button from "devextreme-react/button";

export function Binding() {
    const [bindings, setBindings] = React.useState<TelegramBinding[]>([]);

    React.useEffect(() => {
        load();
    }, []);

    const load = () => telegramService.Binding().then((data) => setBindings(data));

    return (
        <>
            <Button icon="refresh" type="normal" onClick={load} />
            <DataGrid dataSource={bindings}>
                <FilterRow visible />
                <Column dataField="dpaInstanceIdentifier" />
                <Column dataField="telegramUserId" />
            </DataGrid>
        </>
    );
}
